import { C, T } from '@homeschooling/sdk'

import m from 'moment'
import * as React from 'react'
import * as _ from 'lodash'

import Persistance from "../Persistence";
import { InputField } from './InputField'

import { Exit } from '../../Components/Icons'
import { InputSwitch } from 'primereact/inputswitch'
import SDKFactory from '../../Components/SDKFactory'
//import { Calendar } from 'primereact/calendar'
//import { HorizontalLine } from '../Common/HorizonalLine'

import states from 'states-us'

interface Form {
    [key: string]: string
}

export interface Props {
    children?: React.ReactNode
    processForm: (x: Form) => void
    closeForm: () => void
    form: Form
    errors: { [key: string]: string }
}

export interface State {
    form: Form
    students: T.Student[]
    errors: { [key: string]: string }
}

Persistance.setValues()

export class AddStudentForm extends React.Component<Props, any> {
    private studentSdk = SDKFactory.getStudentSDK()

    public constructor(props: Props) {
        super(props)

        this.state = {
            form: [],
            students: Persistance.getStudents()
        }
    }

    public addStudent = () => {

        let errors = this.verifyAddForm()

        if (Object.keys(errors).length !== 0) {
            this.setState({ errors: errors })
            return
        }

        let form = this.state.form
        
                let data: T.Student = {
                    name: form['name'],
                    sex: form['sex'],
                    dob: m(form['dob']).format('YYYY-MM-DD'),
                    grade: form['grade'],
                    special_needs: form['special_needs'] === 'true' ? true : false,
                    city: form['city'],
                    state: form['state']
                }
   
                this.addStudentToSdk(data)
        
            }
        
            public addStudentToSdk = async (data: T.Student) => {
                try {
        
                    const res = await this.studentSdk.createStudent(data)
                    
                    let student = res.data
                    const hasError: boolean = _.get(student, 'errors', false) as boolean
        
                    if (!hasError && res.status === 'success') {
                        student = student as T.Student

                        let students = Persistance.getStudents()
                        students.push(student)
                        Persistance.setStudents(students)
                        this.setState({ form: {} })
                        this.props.closeForm()
                    } else {
                        let error = student as T.ErrorMessage
                        console.log(error)
                        this.setState({errors: {name: error.error}})
                    }
                } catch (reason) {
                    console.log('Error saving student', reason)
                }
            }

    public verifyAddForm = () => {
        const { form } = this.state
        let errors: any = {}

        if (!form.name) errors['name'] = 'Name is required'
        if (!form.sex) errors['sex'] = 'Sex a subject'
        if (!form.dob) errors['dob'] = 'Enter Date of Birth'
        if (!form.grade) errors['grade'] = 'Select a Grade'
        //if (!form.special_needs) errors['special_needs'] = 'Enter special needs'
        if (!form.city) errors['city'] = 'City is required'
        if (!form.state) errors['state'] = 'State is required'

        return errors
    }

    public inputChanged = (key: string) =>
        (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            const { form } = this.state
            form[key] = e.target.value

            this.setState({
                form,
            })
        }

    public setDatePickerFormInfo = (key: string, e: any) => {
        console.log(key, e.target.value)
        const { form } = this.state
        form[key] = m(e.target.value).format()

        this.setState({
            form,
        })

        console.log(this.state.form)
    }

    public toggleSpecialNeeds = () => {
        let special_needs = 'false'

        if (!this.state.form.special_needs || this.state.form.special_needs === 'false') {
            special_needs = 'true'
        }

        const { form } = this.state
        form['special_needs'] = special_needs
        this.setState({ form })
    }

    public getSexOptions = () => {
        let sex = C.sex
        let options: any = []

        _.forOwn(sex, (value, key) => {
            options[key] = value.label
        })

        return options
    }

    public getGradeOption = () => {
        let grades = C.grade

        let options: any = []

        _.forOwn(grades, (value, key) => {
            options[key] = value.label
        })

        return options
    }

    public getStatesOption = () => {
        const nonTerritories = _.filter(states, {territory: false})

        let options: any = []

        nonTerritories.forEach((s) => {
            options[s.abbreviation] = s.name
        })

        return options
    }

    

    public render(): React.ReactNode {

        const { form } = this.state

        return (
            <div className='w-120 flex flex-col'>
                <div className='w-full flex flew-row items-center'>
                    <h2 className='w-auto grow text-left text-l font-semibold text-gray-900'>Add New Student</h2>
                    <div onClick={() => this.props.closeForm()} className='w-auto flex-none text-right justify-items-end hover:cursor-pointer'>
                        <Exit size='small' />
                    </div>
                </div>

                <form noValidate className="space-y-4 md:space-y-6">
                    <div className='w-full flex flex-col'>
                        <div className='w-full my-4'>
                            <InputField
                                borderColor='default'
                                cb={this.inputChanged('name')}
                                disabled={false}
                                errors={this.state.errors?.name}
                                helperErrors={true}
                                label={'Add Event Name'}
                                labelColor='default'
                                id='name'
                                required={true}
                                type='heroText'
                                value={form.name}
                                placeHolder='Student Name'
                            >

                            </InputField>
                        </div>
                        <div className='w-full my-4'>
                            <InputField
                                borderColor='default'
                                cb={this.inputChanged('sex')}
                                disabled={false}
                                errors={this.state.errors?.sex}
                                helperErrors={true}
                                label={'Sex of Student'}
                                labelColor='default'
                                id='sex'
                                required={true}
                                options={this.getSexOptions()}
                                type='select'
                                value={form.sex}
                                placeHolder='Choose A Sex'
                            >

                            </InputField>
                        </div>
                        <div className='w-full my-4 flex flex-row'>
                            <div className='w-full flex flex-row'>
                                <div className='w-auto text-sm text-right pr-4'>
                                    Special Needs
                                </div>
                                <div className='w-auto flex-none text-right'>
                                    <InputSwitch checked={this.state.form.special_needs === 'true'} onChange={(e) => this.toggleSpecialNeeds()} />
                                </div>
                            </div>
                        
                        </div>


                        <div className='w-full grid grid-cols-2 gap-4'>
                            <div>
                            <InputField
                                borderColor='default'
                                cb={this.inputChanged('city')}
                                disabled={false}
                                errors={this.state.errors?.city}
                                helperErrors={true}
                                label={'City'}
                                labelColor='default'
                                id='city'
                                required={true}
                                type='text'
                                value={form.city}
                            >
                                </InputField>
                            </div>
                            <div>
                                <InputField
                                    borderColor='default'
                                    cb={this.inputChanged('state')}
                                    disabled={false}
                                    errors={this.state.errors?.state}
                                    helperErrors={true}
                                    label={'State'}
                                    labelColor='default'
                                    id='state'
                                    required={true}
                                    type='select'
                                    options={this.getStatesOption()}
                                    value={form.state}
                                    placeHolder='State'
                                >

                                </InputField>
                            </div>
                        </div>
                        <div className='w-full my-4 flex flex-row'>
                            <InputField
                                borderColor='default'
                                cb={this.inputChanged('dob')}
                                disabled={false}
                                errors={this.state.errors?.dob}
                                helperErrors={true}
                                label={'Date Of Birth'}
                                labelColor='default'
                                id='dob'
                                required={true}
                                type='text'
                                value={form.dob}
                                placeHolder='MM-DD-YYYY'
                            >

                            </InputField>
                        </div>
                        <div className='w-full my-4 flex flex-col'>
                            <div className='w-full'>
                                <InputField
                                borderColor='default'
                                cb={this.inputChanged('grade')}
                                disabled={false}
                                errors={this.state.errors?.grade}
                                helperErrors={true}
                                label={'Grade'}
                                labelColor='default'
                                id='grade'
                                required={false}
                                options={this.getGradeOption()}
                                type='select'
                                value={form.grade}
                                placeHolder='Grade'
                            >
                            </InputField>
                            </div>
                            <div className='w-full text-xs text-slate-800'>
                                *All students will have their grade auto incremented one year on July 1 until they reach Post Secondary
                            </div>
                        </div>
                        
                        <div className='w-full flex flex-row items-center'>
                            <div className='w-auto hidden grow text-right pr-4'>
                                Add another Student
                            </div>
                            <div className='w-auto flex-none justify-items-right'>
                                <button
                                    onClick={() => this.addStudent()}
                                    type="button"
                                    className="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                    Add Student
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        )
    }

}

export default AddStudentForm